"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCapabilities = exports.getCapabilitiesUrl = void 0;
var utils_1 = require("../utils");
var find_exception_1 = __importDefault(require("./find-exception"));
function getCapabilitiesUrl(url, _a) {
    var _b = _a === void 0 ? { service: undefined, version: undefined } : _a, _c = _b.params, params = _c === void 0 ? {} : _c, service = _b.service, version = _b.version;
    try {
        var _d = new URL(url), origin_1 = _d.origin, pathname = _d.pathname, searchParams = _d.searchParams;
        var base = origin_1 + pathname;
        // params parsed from url
        var baseParams = Object.fromEntries(searchParams.entries());
        var paramsObj = __assign(__assign(__assign({ request: "GetCapabilities" }, baseParams), params), { service: service || (params === null || params === void 0 ? void 0 : params.service) || (0, utils_1.parseService)(url, { case: "upper" }), version: version });
        if (!paramsObj.service) {
            throw new Error("unable to set service parameter");
        }
        return (0, utils_1.formatUrl)(base, paramsObj);
    }
    catch (error) {
        throw Error("getCapabilitiesUrl failed to parse \"".concat(url, "\" because of the following error:\n").concat(error));
    }
}
exports.getCapabilitiesUrl = getCapabilitiesUrl;
function getCapabilities(url, _a) {
    var _b = _a === void 0 ? {} : _a, customFetch = _b.fetch, _c = _b.params, params = _c === void 0 ? {} : _c, service = _b.service, version = _b.version, _d = _b.wait, wait = _d === void 0 ? 0 : _d;
    return __awaiter(this, void 0, void 0, function () {
        var run;
        var _this = this;
        return __generator(this, function (_e) {
            run = function () { return __awaiter(_this, void 0, void 0, function () {
                var capabilitiesUrl, response, xml, exception;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            capabilitiesUrl = getCapabilitiesUrl(url, {
                                params: params,
                                service: service,
                                version: version,
                            });
                            return [4 /*yield*/, (customFetch || fetch)(capabilitiesUrl)];
                        case 1:
                            response = _a.sent();
                            if (response.status !== 200) {
                                throw new Error("fetch failed for \"".concat(capabilitiesUrl, "\" returning a status code of ").concat(response.status));
                            }
                            return [4 /*yield*/, response.text()];
                        case 2:
                            xml = _a.sent();
                            exception = (0, find_exception_1.default)(xml);
                            if (exception) {
                                throw new Error("fetch to \"".concat(capabilitiesUrl, "\" returned the following exception: \"").concat(exception, "\""));
                            }
                            return [2 /*return*/, xml];
                    }
                });
            }); };
            return [2 /*return*/, (0, utils_1.setTimeoutAsync)(wait, run)];
        });
    });
}
exports.getCapabilities = getCapabilities;
